import { render, staticRenderFns } from "./TabsModulePreview.vue?vue&type=template&id=63c4620f&scoped=true&"
import script from "./TabsModulePreview.vue?vue&type=script&lang=js&"
export * from "./TabsModulePreview.vue?vue&type=script&lang=js&"
import style0 from "./TabsModulePreview.vue?vue&type=style&index=0&id=63c4620f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c4620f",
  null
  
)

export default component.exports